import { detectBrowser } from '../../util/util-common';

export const TABLES = {
  advertisement: 'advertisement',
  appanalytics: 'app_analytics',
  apptabs: 'apptabs',
  appuser: 'appuser',
  appuseraccess: 'appuser_access',
  appuserActivity: 'appuser_activity',
  appusergroups: 'appuser_groups',
  appuserNotes: 'appuser_notes',
  bookmarks: 'bookmarks',
  chat: 'chat',
  chatthread: 'chatthread',
  commentlikes: 'commentlikes',
  communityCategory: 'communitycategory',
  communityMember: 'communitymember',
  communitypost: 'communitypost',
  communitypostcomment: 'communitypostcomment',
  communityPostLike: 'communitypostlike',
  communityPostExtra: 'communitypost_extra',
  communityFollower: 'communityfollower',
  docFAQs: 'doc_faqs',
  event: 'event',
  eventForms: 'event_forms',
  eventSettings: 'eventsettings',
  exhibitors: 'exhibitors',
  exhibitorProducts: 'exhibitor_products',
  gallery: 'gallery',
  gallerylikes: 'gallerylikes',
  gamificationChallenge: 'gamification_challenge',
  gameUserPointsLog: 'gamification_user_points_log',
  interests: 'interests',
  interactivemaps: 'interactivemaps',
  liveqa: 'live_qa',
  liveQALikes: 'live_qa_likes',
  liveQAReply: 'live_qa_reply',
  locationmaps: 'locationmaps',
  masterCategory: 'master_category',
  masterIndustry: 'master_industry',
  masterSubCategory: 'master_subcategory',
  meetingnew: 'meeting_new',
  meetingsettings: 'meeting_settings',
  news: 'news',
  notifications: 'notifications',
  orders: 'orders',
  pollResults: 'poll_results',
  pollQuestions: 'poll_questions',
  reportedcontents: 'reported_contents',
  scheduledates: 'scheduledates',
  scheduletracks: 'scheduletracks',
  session: 'session',
  sessionCheckIn: 'session_checkin',
  sessionRatings: 'sessionratings',
  sessionColors: 'sessioncolors',
  sessionRsvp: 'session_rsvp',
  socialFeed: 'socialfeed',
  socialfeedlikes: 'socialfeedlikes',
  socialfeedcomments: 'socialfeedcomments',
  socialfeedpollresult: 'socialfeedpollresult',
  speaker: 'speaker',
  sponsor: 'sponsor',
  surveyResponse: 'survey_response',
  tickets: 'tickets',
  userinterests: 'userinterests',
  userScans: 'userscans',
  webview: 'webview',
  externalLeads: 'external_leads'
};

export const FIELDS = {
  advertisement: { minInfo: '*', mediumInfo: '*', maxInfo: '*' },
  appanalytics: { minInfo: '*', mediumInfo: '*', maxInfo: '*' },
  apptabs: {
    minInfo: 'apptabid',
    mediumInfo:
      'apptabid,displaytabname,tabslected,isenabled,taborder,quicklinkorder',
    maxInfo:
      'apptabid,displaytabname,tabslected,isenabled,taborder,iconimagepath,dark_iconimagepath,quicklinkicon,dark_quicklinkicon,quicklinkorder,backgroundimages'
  },
  appuser: {
    minInfo: 'appuserid,exhibitorid,speakerid,sponsorid',
    mediumInfo:
      'dfid,isactive,isadmin,isinvisible,isnetworking,timezone,userwaitlistmode,usercategory',
    maxInfo: '*',
    relatedInfo:
      'appuserid,eventid,firstname,lastname,profileurl,frameurl,videourl,isactive,isadmin,isinvisible,isnetworking,usercategory,institution,jobtitle,timezone'
  },
  appuseraccess: {
    minInfo: 'orderid,ticketid,ticketurl',
    mediumInfo: '*',
    maxInfo: '*'
  },
  appuserActivity: {
    minInfo: 'activityid',
    mediumInfo: 'activityid,title,description,startdate,enddate,location',
    maxInfo: '*'
  },
  appusergroups: { minInfo: '*', mediumInfo: '*', maxInfo: '*' },
  appuserNotes: { minInfo: '*', mediumInfo: '*', maxInfo: '*' },
  bookmarks: {
    minInfo: 'bookmarkid,typeid',
    mediumInfo: '*',
    maxInfo: '*'
  },
  chat: { minInfo: '*', mediumInfo: '*', maxInfo: '*' },
  chatthread: { minInfo: '*', mediumInfo: '*', maxInfo: '*' },
  commentlikes: { minInfo: '*', mediumInfo: '*', maxInfo: '*' },
  communityCategory: {
    minInfo: 'communitycategoryid',
    mediumInfo:
      'communitycategoryid,categoryname,description,categoryicon,type,postcount,commentcount,totalmember,enableuserposting,enableusercomment,isprivate,questionaire,updatedon,visibility',
    maxInfo: '*'
  },
  communityMember: { minInfo: '*', mediumInfo: '*', maxInfo: '*' },
  communitypost: { minInfo: '*', mediumInfo: '*', maxInfo: '*' },
  communitypostcomment: { minInfo: '*', mediumInfo: '*', maxInfo: '*' },
  communityPostLike: {
    minInfo: 'likedby,icon',
    mediumInfo: '*',
    maxInfo: '*'
  },
  communityPostExtra: {
    minInfo: 'text1,text2,etype,category',
    mediumInfo: 'idextra,text1,text2,etype,exhibitoridfk,sponsorid,category',
    maxInfo: '*'
  },
  communityFollower: {
    minInfo: 'followid',
    mediumInfo: '*',
    maxInfo: '*'
  },
  docFAQs: {
    minInfo: 'category,displaycategoryorder',
    mediumInfo:
      'id,category,title,image,displayorder,type,content,file1,file2,file3,file4,file5,file6,file7,file8,file9,file10',
    maxInfo: '*',
    group: 'category'
  },
  event: {
    minInfo: 'eventid',
    mediumInfo:
      'eventid,eventname,eventicon,eventcover,covervideo,eventdescription,country,eventstartdate,eventenddate,eventtimezone,seocode,eventcode,themecolor,darkthemecolor,clientidfk,group_number,chatinvites,isautopublish_qa,showconvertedtimezone,createdon,iosappstorelink,androidplaystorelink,shownetworkingusercount,announcement,policylisting',
    maxInfo: '*'
  },
  eventForms: {
    minInfo: 'formjson',
    mediumInfo: 'formid,formjson,formlayout,formnumber,formname',
    maxInfo: '*'
  },
  eventSettings: {
    minInfo: 'id',
    mediumInfo:
      'id,eventformid,sesseionratingformid,sponsorformid,exhibitorformid,isloginmandatory,supportemail,eventpolicytype,external_registration_url,showquicklinksonhome,galleryimage,attendeesort,exhibitorsort,sponsorsort,speakersort,all_frames,leadretrievalformid,gamification_title,gamification_desc,meetingsettings,advertisment_settings,overview_settings,reg_login_dates,scheduleview,allowsessionrating,allowspeakerchat,custom_settings,webportal_css,webportal_script,privacy,termsandconditions',
    maxInfo: '*',
    allSettings: [
      'advertisment_settings',
      'all_frames',
      'custom_settings',
      'meetingsettings',
      'overview_settings',
      'reg_login_dates'
    ]
  },
  exhibitors: {
    minInfo: 'exhibitorid,name,country,categoryid',
    mediumInfo:
      'exhibitorid,name,categoryid,booth,featured,featured_order,profileimage,industry',
    maxInfo:
      'exhibitorid,name,eventid,comesfrom,booth,note,featured,featured_order,about,profileimage,bannerimage,promovideo,country,industry,responses,leadretrievalformid,displayorder'
  },
  exhibitorProducts: { minInfo: '*', mediumInfo: '*', maxInfo: '*' },
  gallery: { minInfo: '*', mediumInfo: '*', maxInfo: '*' },
  gallerylikes: { minInfo: '*', mediumInfo: '*', maxInfo: '*' },
  gamificationChallenge: {
    minInfo: 'id,challenge_rule,result,isactive',
    mediumInfo: '*',
    maxInfo: '*'
  },
  gameUserPointsLog: {
    minInfo: 'id,challengeid',
    mediumInfo: 'id,challengeid,points,award',
    maxInfo: '*'
  },
  interests: { minInfo: '*', mediumInfo: '*', maxInfo: '*' },
  // interactivemaps: {
  //   minInfo: 'interactivemapid',
  //   mediumInfo:
  //     'interactivemapid,mapname,mappreview,mapfilepath,mapsize,displayorder',
  //   maxInfo:
  //     'interactivemapid,mapname,mapfilepath,mapsize,displayorder,settingsjson'
  // },
  interactivemaps: { minInfo: '*', mediumInfo: '*', maxInfo: '*' },
  liveqa: { minInfo: '*', mediumInfo: '*', maxInfo: '*' },
  liveQALikes: { minInfo: '*', mediumInfo: '*', maxInfo: '*' },
  liveQAReply: { minInfo: '*', mediumInfo: '*', maxInfo: '*' },
  locationmaps: {
    minInfo: 'mapid',
    mediumInfo:
      'mapid,name,thumbimagepath,location,latitude,longitude,displayorder',
    maxInfo:
      'mapid,name,thumbimagepath,location,latitude,longitude,displayorder'
  },
  masterCategory: {
    minInfo: 'id,name,order',
    mediumInfo: '*',
    maxInfo: '*'
  },
  masterIndustry: {
    minInfo: 'id,name,order',
    mediumInfo: '*',
    maxInfo: '*'
  },
  masterSubCategory: {
    minInfo: 'id,categoryid,name',
    mediumInfo: '*',
    maxInfo: '*'
  },
  meetingnew: {
    minInfo: '*',
    mediumInfo:
      'id,starttime,endtime,title,description,user1,user2,createdby,location,status',
    maxInfo:
      'id,starttime,endtime,title,description,user1,user2,createdby,location,status,isavailable'
  },
  meetingsettings: { minInfo: '*', mediumInfo: '*', maxInfo: '*' },
  news: {
    minInfo: 'newsid,apptabid',
    mediumInfo: 'newsid,apptabid,newstitle,featured,featured_order',
    maxInfo:
      'newsid,apptabid,newstitle,newscontent,newsimage,newsthumbimage,featured,featured_order,createdon'
  },
  notifications: {
    minInfo: 'notificationid',
    mediumInfo: '*',
    maxInfo: '*'
  },
  orders: { minInfo: '*', mediumInfo: '*', maxInfo: '*' },
  pollResults: { minInfo: '*', mediumInfo: '*', maxInfo: '*' },
  pollQuestions: { minInfo: 'sessionid', mediumInfo: '*', maxInfo: '*' },
  reportedcontents: { minInfo: '*', maxInfo: '*' },
  scheduledates: {
    minInfo: 'scheduledate',
    mediumInfo: 'scheduledateid,scheduledate,isactive',
    maxInfo: '*'
  },
  scheduletracks: {
    minInfo: '*',
    mediumInfo:
      'scheduletrackid,scheduledateid,trackname,apptabid,tracksettings',
    maxInfo: '*'
  },
  session: {
    minInfo: 'starttime,title,endtime,eventid,sessiontype,scheduletrackid',
    mediumInfo:
      'starttime,title,endtime,sessionid,eventid,sessiontype,checkintype,scheduletrackid,location,description,tags,colorid,settings',
    maxInfo: '*'
  },
  sessionCheckIn: {
    minInfo: 'id',
    mediumInfo: 'id,checkinbyid,checkouton',
    maxInfo: '*'
  },
  sessionRatings: { minInfo: '*', mediumInfo: '*', maxInfo: '*' },
  sessionColors: { minInfo: '*', mediumInfo: '*', maxInfo: '*' },
  sessionRsvp: { minInfo: '*', mediumInfo: '*', maxInfo: '*' },
  socialFeed: { minInfo: '*', mediumInfo: '*', maxInfo: '*' },
  socialfeedlikes: { minInfo: '*', mediumInfo: '*', maxInfo: '*' },
  socialfeedcomments: { minInfo: '*', mediumInfo: '*', maxInfo: '*' },
  socialfeedpollresult: { minInfo: '*', mediumInfo: '*', maxInfo: '*' },
  speaker: {
    minInfo:
      'speakerid,company,firstname,lastname,profileimage,categoryid,displayorder',
    mediumInfo:
      'speakerid,company,description,enablechat,eventid,featured,firstname,isactive,isfeatured,lastname,position,profileimage,facebook,instagram,linkedin,twitter,country,categoryid,displayorder',
    maxInfo: '*'
  },
  sponsor: {
    minInfo: 'sponsorid,name,categoryid',
    mediumInfo:
      'sponsorid,name,categoryid,sponsor_spoc,logoimgpath,eventid,description,comesfrom,categoryid,displayorder,featured',
    maxInfo: '*'
  },
  surveyResponse: {
    minInfo: 'id,responses',
    mediumInfo: '*',
    maxInfo: '*'
  },
  tickets: {
    minInfo: 'id,ticketname,tickecode',
    mediumInfo: '*',
    maxInfo: '*'
  },
  userinterests: { minInfo: 'appuserid', mediumInfo: '*', maxInfo: '*' },
  userScans: { minInfo: '*', mediumInfo: '*', maxInfo: '*' },
  webview: { minInfo: '*', mediumInfo: '*', maxInfo: '*' }
};

export const SCRIPTS = {
  getCommon: {
    dynamicFilter: {
      endpoint: 'get_common/dynamic_filters',
      payload: {
        type: '' // String | 'attendee'/'exhibitor'
      }
    },
    dynamicFilterUsers: {
      endpoint: 'get_common/search',
      payload: {
        type: 'attendee', // String | 'attendee'/'exhibitor',
        searchText: '' // [] | comma(,) separated array,
      }
    },
    attendees: {
      endpoint: 'get_common/users',
      payload: {
        sort: 'az'
      }
    },
    userInfo: {
      endpoint: 'get_common/userinfo'
    },
    session: {
      endpoint: 'get_common/session',
      payload: {
        apptabid: 0
      }
    },
    myScans: {
      endpoint: 'get_common/myscans'
    },
    poll: {
      endpoint: 'get_common/poll',
      payload: {
        eventid: 0,
        sessionid: 0
      }
    },
    sessionFilters: {
      endpoint: 'get_common/session_filters',
      payload: {
        apptabid: 0
      }
    },
    recommended: {
      endpoint: 'get_common/recommended'
      // get_common/recommended?type=<speaker | exhibitor>
    },
    allowAccess: {
      endpoint: 'get_common/allowaccess',
      payload: {
        eventid: 0
      }
    },
    myItinerary: {
      endpoint: 'get_common/myItinerary',
      payload: null
    }
  },
  postCommon: {
    toggleCommPin: {
      endpoint: 'post_common/toggle_pin',
      payload: {
        eventid: null,
        type: 'communitypost',
        id: null, // communitypostid
        pinned: false // boolean
      }
    },
    togglePin: {
      endpoint: 'post_common/toggle_pin',
      payload: {
        eventid: null,
        type: '', // community | social
        id: null, // primary id
        pinned: '', // 0 | 1
        shift: 0 // -1 up, 1 down, 0 top, 2 bottom
      }
    },
    deleteAcc: {
      endpoint: 'post_common/delete_my_account',
      payload: {}
    },
    socialPollExport: {
      endpoint: 'post_common/social_poll_export',
      payload: {
        eventid: null,
        actiontype: 'social',
        id: null,
        export: true
      }
    },
    sessionPollExport: {
      endpoint: 'post_common/social_poll_export',
      payload: {
        eventid: null,
        actiontype: 'session',
        id: null,
        export: true
      }
    },
    scheduleMeetingPrivate: {
      endpoint: 'post_common/schedule_meeting',
      payload: {
        data: {
          create: {
            eventid: 0,
            starttime: null,
            endtime: null,
            title: '',
            description: '',
            location: '',
            linked_track: null,
            user1: null,
            user2: null
          },
          update: {
            eventid: 0,
            id: null,
            starttime: null,
            endtime: null,
            title: '',
            description: '',
            location: '',
            linked_track: null,
            status: ''
          }
        },
        other: { type: 'attendee', public: false }
      }
    },
    sessionEdit: {
      endpoint: 'post_common/session',
      payload: null // session table columns w/ sessionid, event
    }
  },
  eventQr: {
    sessionQr: {
      endpoint: 'eventqr',
      payload: {
        service: 'sessionqr',
        eventid: 0, // Number
        sessionid: 0 //Number
      }
    },
    myQR: {
      endpoint: 'eventqr',
      payload: {
        userid: 0,
        service: 'myqr'
      }
    }
  },
  user: {
    session: {
      endpoint: 'user/session'
    }
  },
  eventifyScript: {
    exhibitorDetails: {
      endpoint: 'eventifyscript/exhibitordetails',
      payload: {
        eventid: 0,
        appuserid: 0,
        exhibitorid: 0,
        version: 4
      }
    },
    globalSearch: {
      endpoint: 'eventifyscript/globalSearch',
      payload: {
        eventid: 0,
        appuserid: 0,
        searchkey: ''
      }
    },
    sponsorDetails: {
      endpoint: 'eventifyscript/sponsordetails',
      payload: {
        eventid: 0,
        appuserid: 0,
        sponsorid: 0,
        version: 4
      }
    }
  },
  eventifyScriptSupport: {
    appuserAccess: {
      endpoint: 'eventifyscript_support',
      payload: {
        eventid: 0,
        appuserid: 0,
        type: 'appuserAccess'
      }
    },
    appuserCount: {
      endpoint: 'eventifyscript_support',
      payload: {
        eventid: 0,
        type: 'appusercount'
      }
    },
    videoThumb: {
      endpoint: 'eventifyscript_support',
      payload: {
        eventid: 0,
        filename: '',
        foldername: '',
        subfoldername: '',
        thumbname: '',
        type: 'createThumbFromVideo'
      }
    },
    fetchSurveyForm: {
      endpoint: 'eventifyscript_support',
      payload: {
        type: 'fetchSurveyForm',
        appuserid: 0,
        eventid: 0
      }
    }
  },
  userQR: {
    getQR: {
      endpoint: 'userqr?service=getqr',
      payload: {
        userid: 0,
        eventid: 0,
        source: 'inherit'
      }
    },
    exportScan: {
      endpoint: 'userqr?service=exportscans',
      payload: {
        userid: 0,
        eventid: 0
      }
    },
    exportMyData: {
      endpoint: 'userqr',
      payload: {
        eventid: 0,
        userid: 0,
        service: 'exportmydata',
        endpoint: 'myscan',
        response: 'export'
      }
    },
    exportApplicants: {
      endpoint: 'userqr',
      payload: {
        eventid: 0,
        userid: 0,
        service: 'exportmydata',
        endpoint: 'cpostlike',
        response: 'export',
        cpostid: null
      }
    }
  },
  communityScript: {
    endpoint: 'community_script'
  },
  analytics: {
    exhibitorAllHits: {
      endpoint: 'analytics?type=exhibitorsallhits',
      payload: {
        eventid: 0,
        id: 0 // exhibitor id
      }
    },
    sponsorAllHits: {
      endpoint: 'analytics?type=sponsorallhits',
      payload: {
        eventid: 0,
        id: 0 // sponsor id
      }
    },
    appAnalytics: {
      platform: 'web',
      devicename: detectBrowser().browserName,
      model: detectBrowser().browserName,
      systemversion: detectBrowser().fullVersion,
      version: detectBrowser().fullVersion,
      device: '',
      build: '',
      eventid: 0
    }
  },
  gamificationScript: {
    achievements: {
      endpoint: 'gamification_script/achievements',
      payload: {
        eventid: 0,
        userid: 0
      }
    },
    leaderboard: {
      endpoint: 'gamification_script/leaderboard',
      payload: {
        eventid: 0,
        userid: 0
      }
    },
    teamLeaderBoard: {
      endpoint: 'gamification_script/leaderboard_grouped',
      payload: {
        eventid: 0,
        userid: 0
      }
    },
    fetchGameChallengeStatus: {
      endpoint: 'gamification_script/challenge_status',
      payload: {
        eventid: 0,
        userid: 0,
        challengetype: ''
      },
      triviaPayload: {
        eventid: 0,
        userid: 0,
        challengetype: '',
        relatedid: null,
        apptabid: null
      }
    }
  },
  meetingSlots: {
    endpoint: 'meetingslots',
    payload: {
      eventid: 0,
      sender: 0, // session user
      receiver: 0 // other party
    }
  },
  liveQA: {
    delete: {
      endpoint: 'liveqa',
      payload: {
        requesttype: 'delete',
        sessionid: 0,
        qaid: 0,
        userid: 0
      }
    },
    noSubmittedPoll: {
      endpoint: 'liveqa',
      payload: {
        requesttype: 'notsubmittedpoll',
        sessionid: 0,
        userid: 0
      }
    }
  },
  networkUsers: {
    unreadCount: {
      endpoint: 'networkusers',
      payload: {
        appuserid: 0,
        eventid: 0,
        section: 'onlyunreadcount'
      }
    },
    chatThreads: {
      endpoint: 'networkusers',
      payload: {
        appuserid: 0,
        eventid: 0,
        section: 'chatthreads'
      }
    },
    chatThreadsSearch: {
      endpoint: 'networkusers',
      payload: {
        appuserid: 0,
        eventid: 0,
        search: '',
        section: 'chatthreads'
      }
    },
    filterBySearch: {
      endpoint: 'networkusers',
      payload: {
        appuserid: 0,
        eventid: 0,
        term: '',
        section: 'filter_by_search'
      }
    },
    suggestionsV2: {
      endpoint: 'networkusers',
      payload: {
        appuserid: 0,
        eventid: 0,
        section: 'suggestions_v2'
      }
    }
  },
  magicEmail: {
    endpoint: 'magicemail',
    payload: {
      email: '',
      eventid: 0,
      apcode: '',
      calledfrom: 'webportal'
    }
  },
  verifyToken: {
    endpoint: 'verifytoken',
    payload: {
      eventid: '',
      passcode: '',
      token: ''
    }
  },
  customScript: {
    endpoint: '/custom_script',
    payload: {
      eventid: '',
      apptabid: '',
      appuserid: '',
      type: 'downloadschedules'
    }
  }
};

/**
 * NOTE:
 * If order updates, do change the respective internal order too
 */
export const FETCH_ORDERS = {
  activity: encodeURI('createdon DESC'),
  apptabs: 'taborder',
  locationmaps: {
    api: 'displayorder',
    internal: { fields: ['displayorder'], order: ['asc'] }
  },
  session: encodeURI('starttime,title,createdon'),
  sessionInternal: {
    fields: ['starttime', 'title', 'createdon'],
    order: ['asc', 'asc', 'asc']
  },
  sponsor: {
    name: encodeURI('featured DESC,name'),
    random: encodeURI('featured DESC,displayorder,sponsorid'),
    nameInternal: {
      fields: ['featured', 'name'],
      order: ['desc', 'asc']
    },
    randomInternal: {
      fields: ['featured', 'displayorder', 'sponsorid'],
      order: ['desc', 'asc', 'asc']
    }
  },
  exhibitor: {
    name: encodeURI('name,featured DESC'),
    booth: encodeURI('booth,featured DESC'),
    random: encodeURI('displayorder,featured DESC'),
    nameInternal: {
      fields: ['name', ' featured '],
      order: ['asc', 'desc']
    },
    boothInternal: {
      fields: ['booth', ' featured '],
      order: ['asc', 'desc']
    },
    randomInternal: {
      fields: ['displayorder', ' featured '],
      order: ['asc', 'desc']
    }
  },
  speaker: {
    name: encodeURI('firstname,lastname'),
    random: 'displayorder',
    nameInternal: {
      fields: ['firstname', 'lastname'],
      order: ['asc', 'asc']
    },
    randomInternal: { fields: ['displayorder'], order: ['asc'] }
  },
  communityCategory: encodeURI('updatedon DESC'),
  communitypost: encodeURI('pinorder,updatedon DESC'),
  communitypostcomment: encodeURI('unixtimestamp DESC'),
  meetingnew: 'starttime',
  scheduledates: 'scheduledate',
  scheduletracks: 'displayorder',
  masterCategory: {
    api: encodeURI('createdon DESC'),
    internal: { fields: 'order', order: 'asc' }
  },
  masterIndustry: {
    api: encodeURI('createdon DESC'),
    internal: { fields: 'order', order: 'asc' }
  },
  masterSubCategory: encodeURI('createdon DESC'),
  news: encodeURI('featured DESC,createdon DESC'),
  interests: {
    api: encodeURI('category_display_order,interest_display_order'),
    internal: {
      fields: ['category_display_order', 'interest_display_order'],
      order: ['asc', 'asc']
    }
  }
};
